import React from "react";
import classNames from "classnames";
import type { CSSProperties } from "react";
import normalClasses from "../../Normal/NormalMode/NormalMode.module.scss";
import type { TerminalChildrenModeButtonShape } from "../../../../../types/Admin/TerminalAppearanceTypes";
import type { ChildrenModeIconMeta } from "./ChildrenModeCardSpace";

type ChildrenModeCardKidsBaseProps = {
  themeClassName?: string;

  isCategory: boolean;
  isService: boolean;
  isActiveNow: boolean;
  shouldHideOuterCircle: boolean;
  ticketCircleStyle?: CSSProperties;

  ticketName: string;
  isChildrenMode: boolean;

  childrenButtonShape: TerminalChildrenModeButtonShape;
  childrenIconMeta: ChildrenModeIconMeta | null;
  childrenTileColor?: string;
  childrenTileTextColor?: string;
};

export const ChildrenModeCardKidsBase: React.FC<
  ChildrenModeCardKidsBaseProps
> = ({
  themeClassName,
  isCategory,
  isService,
  isActiveNow,
  shouldHideOuterCircle,
  ticketCircleStyle,
  ticketName,
  isChildrenMode,
  childrenButtonShape,
  childrenIconMeta,
  childrenTileColor,
  childrenTileTextColor,
}) => {
  return (
    <div
      className={classNames(
        {
          [normalClasses.active]: isService && isActiveNow,
          [normalClasses.ticketCardSmall]: !isCategory,
          [normalClasses.ticketCardLarge]: isCategory,
          [normalClasses.ticketCardCompact]:
            shouldHideOuterCircle && !isChildrenMode,
          [normalClasses.childrenModeTile]: isChildrenMode,
          [normalClasses.childrenTileRectangle]:
            isChildrenMode && childrenButtonShape === "RECTANGLE",
          [normalClasses.childrenTileCircle]:
            isChildrenMode && childrenButtonShape === "CIRCLE",
          [normalClasses.childrenTileCloud]:
            isChildrenMode && childrenButtonShape === "CLOUD",
          [normalClasses.childrenModeTileNoIcon]:
            isChildrenMode && shouldHideOuterCircle,
        },
        themeClassName,
      )}
      style={
        isChildrenMode && childrenTileColor
          ? ({
              "--children-tile-color": childrenTileColor,
              "--children-tile-text-color": childrenTileTextColor,
            } as CSSProperties)
          : undefined
      }
    >
      {childrenIconMeta ? (
        <div className={normalClasses.childrenModeIconSlot}>
          <img
            className={normalClasses.childrenModeIconImage}
            src={childrenIconMeta.src}
            alt=""
            draggable={false}
            style={{
              objectFit: childrenIconMeta.objectFit,
              objectPosition: childrenIconMeta.objectPosition,
              ...(childrenIconMeta.scale !== 100
                ? { transform: `scale(${childrenIconMeta.scale / 100})` }
                : {}),
            }}
          />
        </div>
      ) : (
        !shouldHideOuterCircle && (
          <div
            className={classNames({
              [normalClasses.ticketOuterCircleSmall]: !isCategory,
              [normalClasses.ticketOuterCircleLarge]: isCategory,
            })}
            style={ticketCircleStyle}
          />
        )
      )}

      <div className={normalClasses.ticketTextWrapper}>
        <div
          className={classNames(normalClasses.ticketTextScroll, {
            [normalClasses.ticketTextScrollSection]: isCategory,
          })}
        >
          <span>{ticketName}</span>
        </div>
      </div>

      <div
        className={classNames({
          [normalClasses.cropLineShow]: !isCategory,
          [normalClasses.cropLineHide]: isCategory,
        })}
      ></div>
    </div>
  );
};
